import { useEffect } from "react";

const GA_ID = "G-C0B89LVKWK";
const COOKIE_KEY = "hp_cookie_consent";

const GoogleAnalytics = () => {
  useEffect(() => {
    const checkAndLoad = () => {
      try {
        const stored = localStorage.getItem(COOKIE_KEY);
        if (!stored) return;
        const consent = JSON.parse(stored);
        if (!consent.analytics) return;
      } catch {
        return;
      }

      // Don't load twice
      if (document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) return;

      // Load gtag.js
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);

      // Initialize dataLayer
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", GA_ID, { anonymize_ip: true });
    };

    checkAndLoad();

    // Re-check when consent changes
    const handleStorage = (e) => {
      if (e.key === COOKIE_KEY) checkAndLoad();
    };
    window.addEventListener("storage", handleStorage);

    // Also listen for same-tab updates
    const interval = setInterval(() => {
      if (!document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) {
        checkAndLoad();
      } else {
        clearInterval(interval);
      }
    }, 2000);

    return () => {
      window.removeEventListener("storage", handleStorage);
      clearInterval(interval);
    };
  }, []);

  return null;
};

export default GoogleAnalytics;
